import React from "react"
import {
  listAddressesContainer,
  listAddressesTitle,
  listAddressesHeader,
  addressesContainer,
  addressesDescription,
  allAddresses,
  allAddressesResponsive,
} from "./carnet-adresse.module.scss"
import { Container, Title } from "./carnet-adresse-styled"
import ContentTransformer from "gatsby-theme-blank/src/components/Transformers/content-transformer"
import TransitionFade from "gatsby-theme-blank/src/components/transition-fade"
import RenderAddresses from "./RenderAddresses/render-addresses"
import { useCarnetAdresse } from "gatsby-theme-blank/src/components/Home/CarnetAdresse/carnet-adresse-query"

//-----------------------Parent component---------------------------//

const CarnetAdresse = () => {
  const data = useCarnetAdresse()
  if (data.allNodeCarnetDAdresse.edges.length === 0) {
    return null
  }
  return (
    <Container className={listAddressesContainer}>
      <div className={listAddressesHeader}>
        <Title className={listAddressesTitle}>
          {data.taxonomyTermZoneDefinie?.field_label || "Carnet d'addresses"}
        </Title>
        <div className={allAddresses}>
          <TransitionFade className="btn" link="/adresses">
            Voir la carte
          </TransitionFade>
        </div>
      </div>
      {data.taxonomyTermZoneDefinie.description && (
        <div className={addressesDescription}>
          <ContentTransformer
            content={data.taxonomyTermZoneDefinie.description.processed}
          ></ContentTransformer>
        </div>
      )}
      <div className={addressesContainer}>
        <RenderAddresses addressesData={data} />
      </div>
      <div className={allAddressesResponsive}>
        <TransitionFade className="btn" link="/adresses">
          Voir le carnet d&apos;adresse
        </TransitionFade>
      </div>
    </Container>
  )
}

//-----------------------Parent component---------------------------//

export default CarnetAdresse
